import { useCallback, useEffect, useState } from "react";
import Utils from "../utils/functions";
import apiClient from "../services/apiClient";

const useQueryResource = (url, resourceName) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const refetch = useCallback(async (path, resourceName, pageSize) => {
    const defaultPageSize = pageSize || 100;
    if (path) {
      setLoading(true);
      await apiClient
        .get(`${path}?includeAllProps=true&size=${defaultPageSize}`)
        .then((res) => res.data)
        .then((data) => {
          setLoading(false);
          const resources = data._embedded[resourceName]?.map((resource) => {
            return {
              ...resource,
              createdAt: Utils.formatDate.toLocaleDateString(
                resource.createdAt
              ),
              lastModfiedAt: Utils.formatDate.toLocaleDateString(
                resource.lastModfiedAt
              ),
            };
          });
          setData(resources);
        })
        .catch((err) => {
          setLoading(false);
          setError(
            err?.response?.data?.errors?.map((e) => e.message).join(", ") ||
              err.message
          );
        });
    }
  }, []);

  useEffect(() => {
    refetch(url, resourceName);
  }, [url, resourceName, refetch, setLoading, setError, setData]);

  return { loading, data, error, refetch };
};

export default useQueryResource;
